import LearningListContainer from "../../../components/miscellaneous/learning/learningList";

const LearningList = () => {
  return <LearningListContainer />;
};

export default LearningList;
